export default {
  undefined: 'Indefinido',
};
